import styled from "styled-components"

import { Box } from "components/common"

const Section = styled(Box).attrs(props => ({
  bg: props.hasBg ? "grey.4" : "transparent",
  mb: 4,
  px: { _: 2, tablet: 0 },
  py: props.hasBg ? 4 : 0,
  ...props
}))``

export default Section
